import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ 
  title = "Taar.AI", 
  subtitle = "", 
  showActions = true,
  actions = []
}) => {
  return (
    <header className="border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="https://assets.taar.ai/logo.png" 
                alt="Taar.AI" 
                className="h-8 w-auto" 
                style={{maxHeight: '32px'}}
              />
            </Link>
            {subtitle && (
              <span className="ml-4 text-sm text-gray-500">{subtitle}</span>
            )}
          </div>
          
          {/* Header Actions */}
          {showActions && (
            <div className="flex items-center space-x-4">
              {actions.length > 0 ? (
                actions.map((action, index) => (
                  <a
                    key={index}
                    href={action.href}
                    target={action.target || "_self"}
                    rel={action.rel || ""}
                    className={action.className || "text-gray-500 hover:text-gray-700"}
                  >
                    {action.children}
                  </a>
                ))
              ) : (
                <>
                  <button className="p-2 text-gray-500 hover:text-gray-700">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  </button>
                  <button className="p-2 text-gray-500 hover:text-gray-700">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </button>
                  <button className="p-2 text-gray-500 hover:text-gray-700">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
